import { useQuery } from "@tanstack/react-query";

import { courseMaterialsApi, type ResourcePlacement } from "@/lib/api/courseMaterials";

import { historyKey } from "./use-material-library";

/**
 * The date of a published material's latest correction, as learners read it
 * ("Updated {date}"), or null when it was never corrected.
 */
export function useLatestCorrection(courseId: string, placement: ResourcePlacement | null): string | null {
  const published = placement?.publication_status === "published" && placement.reference_kind === "material";
  const history = useQuery({
    queryKey: historyKey(courseId, placement?.id ?? ""),
    queryFn: () => courseMaterialsApi.getResourcePlacementHistory(courseId, placement?.id ?? ""),
    enabled: published,
  });
  if (!published) return null;
  const correction = history.data?.find((event) => event.event_kind === "material_correction");
  return correction ? new Date(correction.created_at).toLocaleDateString() : null;
}
